import { map, take } from 'rxjs/operators';
import { ListSearchCriteriaState, ListSearchCriteriaStateModel } from './list-search-criteria.state';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ChangeSearchCriteriaByListType, SearchCriteriaInitialStateByListType } from './list-search-criteria.actions';
import { SearchCriteria } from '../../../common/models';
import { ListSearchCriteriaType } from './constants/list-search-criteria-type.constant';

@Injectable({ providedIn: 'root' })
export class ListSearchCriteriaFacade {
  state$: Observable<ListSearchCriteriaStateModel> = this.store.select(ListSearchCriteriaState.getState);

  constructor(private store: Store) {}

  select$(listType: ListSearchCriteriaType): Observable<SearchCriteria> {
    return this.store
      .select(ListSearchCriteriaState.getSearchCriteriaByListType)
      .pipe(map((pickFn: (type: ListSearchCriteriaType) => SearchCriteria) => pickFn(listType)));
  }

  getSearchCriteriaByListType(listType: ListSearchCriteriaType): Observable<SearchCriteria> {
    return this.store.select(ListSearchCriteriaState.getSearchCriteriaByListType).pipe(
      map((pickFn: (type: ListSearchCriteriaType) => SearchCriteria) => pickFn(listType)),
      take(1),
    );
  }

  changeSearchCriteriaByListType(
    searchCriteria: Partial<SearchCriteria>,
    listSearchCriteriaType: ListSearchCriteriaType,
  ): void {
    this.store.dispatch(
      new ChangeSearchCriteriaByListType({
        searchCriteria,
        listSearchCriteriaType,
      }),
    );
  }

  setInitialStateByType(type: ListSearchCriteriaType): void {
    this.store.dispatch(new SearchCriteriaInitialStateByListType(type));
  }
}
